import { useMemo } from 'react';

export const useCustomInputTheme = (customTheme) => {
    return useMemo(
        () =>
            customTheme && {
                input: {
                    backgroundColor: customTheme.inputBackgroundColor,
                    color: customTheme.inputTextColor,
                    border: 'none',
                    borderRadius: customTheme.borderRadius,
                },
                error: {
                    color: customTheme.inputTextColor,
                    padding: '2px 8px',
                    backgroundColor: customTheme.inputBackgroundColor,
                    display: 'inline-block',
                    borderRadius: customTheme.borderRadius,
                },
            },
        [customTheme]
    );
};
